export const links = {
	airbnb: null,
	booking: null,
	google: 'https://www.google.com/search?sa=X&sca_esv=07f2b446eda3f237&sca_upv=1&biw=1644&bih=861&tbm=lcl&sxsrf=ADLYWIJ9yLBWZCKfBrNBDIgTZTBQbRTUaw:1725708358506&q=osvrti%20za%20apartmani%20fradol%20tu%C4%8Depi&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDcyNjA3MDA0M7a0NDAzsTCzMNzAyPiKUSm_uKyoJFOhKlEhsSCxqCQ3MS9TIa0oMSU_R6Gk9EhvakHmIlYiFAEAdLMcc2UAAAA&rldimm=17230700163990648681&hl=hr-HR&ved=0CAYQ5foLahcKEwjw45XU3LCIAxUAAAAAHQAAAAAQBQ#lkt=LocalPoiReviews&arid=ChdDSUhNMG9nS0VJQ0FnSUNwbzU2MTZRRRAB',
};

export const reviewSources = {
	'airbnb': {
		name: 'Airbnb',
		link: links.airbnb,
		icon: '/images/icons/airbnb_icon.png',
	},
	'booking': {
		name: 'Booking.com',
		link: links.booking,
		icon: '/images/icons/booking_icon.png',
	},
	'google': {
		name: 'Google',
		link: links.google,
		icon: '/images/icons/google_icon.png',
		reviewLink: 'https://www.google.com/search?sa=X&sca_esv=07f2b446eda3f237&sca_upv=1&biw=1644&bih=861&tbm=lcl&sxsrf=ADLYWIJ9yLBWZCKfBrNBDIgTZTBQbRTUaw:1725708358506&q=osvrti%20za%20apartmani%20fradol%20tu%C4%8Depi&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDcyNjA3MDA0M7a0NDAzsTCzMNzAyPiKUSm_uKyoJFOhKlEhsSCxqCQ3MS9TIa0oMSU_R6Gk9EhvakHmIlYiFAEAdLMcc2UAAAA&rldimm=17230700163990648681&hl=hr-HR&ved=0CAYQ5foLahcKEwjw45XU3LCIAxUAAAAAHQAAAAAQBQ#arid=ChdDSUhNMG9nS0VJQ0FnSUNwbzU2MTZRRRAB&lkt=LocalPoiReviews&lrd=0x134af0294b2e1da7:0xef1fbe81c9ed7769,3,,,,',
	},
};

export const reviews = [
	{
		name: 'Jarko',
		date: 'September 2024',
		rating: 5,
		comment: 'reviews.jarko',
		source: 'google',
	},
	{
		name: 'Roman',
		date: 'July 2023',
		rating: 5,
		comment: 'reviews.roman',
		source: 'google',
	},
	{
		name: 'Mehmed',
		date: 'August 2022',
		rating: 5,
		comment: 'reviews.mehmed',
		source: 'google',
	},

	{
		name: 'Tomasz',
		date: 'July 2021',
		rating: 5,
		comment: 'reviews.tomasz',
		source: 'google',
	},
	{
		name: 'Tranx',
		date: 'August 2020',
		rating: 5,
		comment: 'reviews.tranx',
		source: 'google',
	},
];
